import CheckInItem from './CheckInItem';

export default CheckInItem;
